//validateCNPJ foi pego uma função pronta
const validateCNPJ = value => {
  const cnpj = value.replace(/[^\d]+/g, '')
  const sequencialNumbersRegex = /^(\d)\1+$/g
  const isSequencialNumber = sequencialNumbersRegex.test(cnpj)

  if (!cnpj) return false
  if (cnpj.length !== 14) return false
  if (isSequencialNumber) return false

  // Valida DVs
  let cnpjSizeWithoutVerificationDigit = cnpj.length - 2
  let cnpjWithouVerificationDigit = cnpj.substring(0, cnpjSizeWithoutVerificationDigit)
  let verificationDigits = cnpj.substring(cnpjSizeWithoutVerificationDigit)
  let sum = 0
  let pos = cnpjSizeWithoutVerificationDigit - 7

  for (let i = cnpjSizeWithoutVerificationDigit; i >= 1; i--) {
    sum += cnpjWithouVerificationDigit.charAt(cnpjSizeWithoutVerificationDigit - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }

  let resultado = sum % 11 < 2 ? 0 : 11 - (sum % 11)
  if (resultado != verificationDigits.charAt(0)) {
    return false
  }

  cnpjSizeWithoutVerificationDigit = cnpjSizeWithoutVerificationDigit + 1
  cnpjWithouVerificationDigit = cnpj.substring(0, cnpjSizeWithoutVerificationDigit)
  sum = 0
  pos = cnpjSizeWithoutVerificationDigit - 7

  for (let i = cnpjSizeWithoutVerificationDigit; i >= 1; i--) {
    sum += cnpjWithouVerificationDigit.charAt(cnpjSizeWithoutVerificationDigit - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }

  resultado = sum % 11 < 2 ? 0 : 11 - (sum % 11)
  if (resultado !== parseInt(verificationDigits.charAt(1))) {
    return false
  }

  return true
}

const maskCNPJ = value => {
  if (!value) return { maskedCnpj: '', unmaskedCnpj: '' }

  const unmaskedCnpj = value.replace(/\D/g, '')
  let cnpj = unmaskedCnpj.replace(/^(\d{2})(\d)/, '$1.$2')
  cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
  cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2')
  cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2')
  return { maskedCnpj: cnpj.substring(0, 18), unmaskedCnpj }
}

export { validateCNPJ, maskCNPJ }
